import React, {FC, useCallback, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import Confetti from 'react-confetti';
// custom
import logo from '../../../assets/img/trophy.png'; 
import NavbarUser from '../../../components/navbar/Navbar.user';
import './payment.page.css';
import { useSelector } from 'react-redux';
import { IUserState } from '../../../common/state/profile/user';
import { retrieveLocalStorageItem } from '../../../common/helpers/LocalStorage';
import { postSubscriptionEmail, retrieveSubscriptionDetails, updateSubscriptionStatusById } from '../../../common/async/AsyncCalls';
import { ISubscriptionResponse } from '../../../common/state/subscriptions/subscription';
import { toast } from 'react-toastify';

const PaymentSuccessView: FC = () => {
    // confetti settings
    const [width, setWidth] = useState<number>(document.body.clientWidth);
    const [height, setHeight] = useState<number>(document.body.clientHeight);
    const [confettiRun, toggleConfettiRun] = useState<boolean>(true);

    // states
    const token = useSelector(({user} : {user: IUserState}) => user.token);
    let subscriptionId = retrieveLocalStorageItem('subscription');
    subscriptionId = remove_special_chars(subscriptionId);

    // lifecycle
    const triggerSalesCompleteEmails = useCallback(async()=>{
        if (!token || token === '' || !subscriptionId || subscriptionId === '') return ;
        try {
            
            const subscriptionResponse = await retrieveSubscriptionDetails(token, subscriptionId);
            const subscriptionDetails: ISubscriptionResponse = subscriptionResponse?.data as ISubscriptionResponse;
            const triggerEmailList = [
                updateSubscriptionStatusById(token, subscriptionId, 'success'),
                postSubscriptionEmail(token, {
                    reg_type: subscriptionDetails.general_info.reg_type,
                    event: subscriptionDetails.general_info.event_title,
                    name: `${subscriptionDetails.payment_info.first_name} ${subscriptionDetails.payment_info.last_name}`,
                    receipt: subscriptionId,
                    payment_date: new Date().toISOString(),
                    vendor: 'Stripe',
                    amount: subscriptionDetails.general_info.final_price
                })
            ];
            await Promise.all(triggerEmailList);
            toast(`Subscription updated!`);
        } catch (err) {
             console.log('Error - updating email and subscription: ', err);
        } 
    },[token, subscriptionId]);

    useEffect(()=>{
        // #1. Confetti settings
        setWidth(document.body.clientWidth);
        setHeight(document.body.clientHeight);
        setTimeout(() => toggleConfettiRun(false), 5000);

        // #2. Send emails
        triggerSalesCompleteEmails();

        // #3. Remove the parameters from the URL
        setTimeout(()=>{
            let url = window.location.href;
            let newUrl = url.replace(/\?.*/, '');                        
            window.history.replaceState({}, '', newUrl)},3000);
    },[]);
    return <React.Fragment>
        <Confetti
                width={width}
                height={height}
                numberOfPieces={100}
                recycle={confettiRun}/>
        <NavbarUser />
        <div
            className="flex flex-col items-center justify-center h-screen overflow-y-scroll text-gray-700 bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dartext-base">
            <div className="flex flex-col items-center justify-center max-w-md overflow-hidden bg-gray-100 rounded shadow-lg fadeIn slideInUp">
                <img className="w-1/2 mt-6" src={logo} alt="Sunset in the mountains" />
                <div className="flex flex-col items-center justify-center px-6 py-4">
                    <div className="mb-2 text-xl font-bold text-blue-800">Event Registration Success</div>
                    <p className="mb-4 text-gray-700 dartext-base">
                        Congratulations! you've successfully registered for the conference
                    </p>
                    <p className="mb-4 text-sm text-gray-700 dartext-base">
                        You will soon receive an email from us regarding the conference details. For any clarification, please feel free to reach out to our team
                    </p>
                </div>
                <div className="px-6 pt-4 pb-2">
                    <Link to="/profile" className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-100 rounded-full bg-secondary-500">Home</Link>                                        
                </div>
            </div>
        </div>
    </React.Fragment>
};

export default PaymentSuccessView;

export function remove_special_chars(input: string): string {
    input = input.replace(/['"]/g, '');
    return input.trim();
}